<div class="headerMain sidebar-wrapper ps">

  <div class="logoCol" [ngStyle]="{'background-image': 'url(/assets/img/logo-squirrel-klein.png)'}">
  </div>
  <div class="environmentCol">
    <p class="clickable">
    </p>
  </div>

  <div class="legacyCol" >
    <p class="clickable">
    </p>
  </div>

  <div class="tenantCol" *ngIf="tenantName">
    <p class="clickable" title="Mandanten wechseln"
       [routerLink]="['/', 'select-tenant']">
          <i class="material-icons">work</i>
      {{tenantName}}
    </p>
  </div>

  <div class="userCol">
    <p class="clickable abbrev" title="Benutzer" href="javascript:void(0)" [mat-menu-trigger-for]="menu" data-toggle="dropdown"><i class="material-icons">person</i> {{username}}</p>
    <!-- <a class="nav-item dropdown nav-link"  -->
    aria-haspopup="true" aria-expanded="false" style="color: #303f6f;">
    <!-- <i class="material-icons">person</i>
    {{name}} -->
  <!-- </a> -->
</div>


<!--   
  <a class="nav-link" href="javascript:void(0)" id="navbarDropdownMenuLink" data-toggle="dropdown"
  aria-haspopup="true" aria-expanded="false" style="color: #303f6f;">
  </a>
  <div class=" dropdown-menu dropdown-menu-right squirrel-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
    <a *ngFor="let item of items" class="dropdown-item {{item.icon}}" [routerLink]="[item.path]">
        {{this.translate.data[item.text] | translate}}
    </a>
    <a *ngFor="let info of userInfos" class="dropdown-item">
        {{this.translate.data[info.label] | translate}} {{tenantname}}
  
    </a>
  </div>
   -->

</div>

<mat-menu  #menu="matMenu">
  <a class="blueLetters" *ngFor="let item of items" class="dropdown-item {{item.icon}}" [routerLink]="[item.path]">
      {{this.translate.data[item.text] | translate}}
  </a>
  <a class="blueLetters" *ngFor="let info of userInfos" class="dropdown-item">
      <!-- {{this.translate.data[info.label] | translate}} {{info.text}}  -->
      {{this.translate.data[info.label] | translate}} {{tenantname}}

  </a>
</mat-menu>


